import classNames from 'classnames'
import styles from 'sections/encyclopedia-articles-reference/EncyclopediaArticlesReference.module.scss'
import Link from 'next/link'
import { routes } from 'utils/routes'
import { EncyclopediaArticlesReferenceProps } from 'sections/encyclopedia-articles-reference/types'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next/pages'
import { Heading, Img } from '@boltenergy-be/design-system'

const EncyclopediaArticlesReference = ({ articles }: EncyclopediaArticlesReferenceProps) => {
  // Router
  const router = useRouter()

  // i18n
  const { t } = useTranslation('common')

  return (
    <section className={classNames('section container', styles['article-section'])}>
      <ul className={styles.list}>
        {articles?.map((article) => (
          <li key={article.slug}>
            <Link
              className={styles['article-card']}
              href={routes(router.locale, '', [article.category.slug, article.slug]).encyclopediaArticle}
            >
              <figure className={styles['thumbnail-wrapper']}>
                <Img
                  fill
                  publicId={article.thumbnail.provider_metadata.public_id}
                  alt={`${t('thumbnail', 'thumbnail')} ${article.title}`}
                  className={styles.thumbnail}
                />
              </figure>
              <div className={styles.content}>
                <Heading as="h3" variant="h4" serif>
                  {article.title}
                </Heading>
                <div>
                  <p className="truncate">{article.description}</p>
                </div>
                <span className={styles.link}>{t('encyclo.readMore', 'Lees er meer over')}</span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default EncyclopediaArticlesReference
